import { useEffect, useState } from 'react';
import ModuleFilters, { TgetFiltersList } from '../../../../components/ModuleFilters/ModuleFilters';
import useFiltersState from '../../../../state/useFiltersState';
import { ICountryDetail } from '../../../../types/countries';
import { getListOfCountriesByOfferedService } from '../../../../utils/getCountries';
import './LogisticServiceListingFilter.scss';

const LogisticServiceListingFilter = () => {
  const { logisticsServicesListingFilters, setLogisticsServicesListingFilters } = useFiltersState();
  const [openStateFilter, setOpenStateFilter] = useState<boolean>(false);
  const [openOriginCountryFilter, setOpenOriginCountryFilter] = useState<boolean>(false);
  const [openDestinationCountryFilter, setOpenDestinationCountryFilter] = useState<boolean>(false);
  const [countriesOpenToLogistics, setCountriesOpenToLogistics] = useState<ICountryDetail[]>();

  const servicesRawOption = ['Por confirmar', 'Confirmado', 'En proceso', 'Activo', 'Atrasado', 'Entregado'];

  const catalogueFilterMapping = {
    Estado: 'status',
    Origen: 'origin',
    Destino: 'destination',
  };

  const countryNameToCodeMap: Map<string, string> = countriesOpenToLogistics
    ? new Map(countriesOpenToLogistics?.map(countryData => [countryData.name, countryData.code]))
    : new Map();

  const logisticsCountriesRawOptions =
    countriesOpenToLogistics && countriesOpenToLogistics.length
      ? countriesOpenToLogistics.reduce<string[]>((accum, current) => {
          if (current?.name) accum.push(current.name);
          return accum;
        }, [])
      : undefined;

  const getCatalogueFiltersList: TgetFiltersList = (
    formModuleFilters,
    handleClickFilterOption,
    getFilterActiveStatus
  ) => [
    {
      title: 'Estado',
      openFunction: setOpenStateFilter,
      openStatus: openStateFilter,
      rawSelectOptions: formModuleFilters('Estado', servicesRawOption),
      handleChangeSelectedOption: handleClickFilterOption('status', 'value'),
      isFilterActive: getFilterActiveStatus('status')
    },
    {
      title: 'Origen',
      openFunction: setOpenOriginCountryFilter,
      openStatus: openOriginCountryFilter,
      rawSelectOptions: formModuleFilters('Origen', logisticsCountriesRawOptions, countryNameToCodeMap),
      handleChangeSelectedOption: handleClickFilterOption('origin', 'value'),
      isFilterActive: getFilterActiveStatus('origin')
    },
    {
      title: 'Destino',
      openFunction: setOpenDestinationCountryFilter,
      openStatus: openDestinationCountryFilter,
      rawSelectOptions: formModuleFilters('Destino', logisticsCountriesRawOptions, countryNameToCodeMap),
      handleChangeSelectedOption: handleClickFilterOption('destination', 'value'),
      isFilterActive: getFilterActiveStatus('destination')
    }
  ];

  useEffect(() => {
    getListOfCountriesByOfferedService(setCountriesOpenToLogistics, 'logisticService');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="LogisticServiceListingFilter">
      <ModuleFilters
        customGap={24}
        moduleFilters={logisticsServicesListingFilters}
        getFiltersList={getCatalogueFiltersList}
        countryCondition={true}
        setModuleFilters={setLogisticsServicesListingFilters}
        moduleFiltersTitlesMapping={catalogueFilterMapping}
      />
    </div>
  );
};

export default LogisticServiceListingFilter;
